import Base from "../composition/Base";
import Cluster from "../composition/Cluster";
import Light from "../composition/Light";
import Pendant from "../composition/Pendant";
import Composition, { CompositionElement } from '../composition/Composition';
import Group, { ComposableElement } from "../composition/Group";
import Space, { SpaceElement } from "../composition/Space";
import { DomainModelsData } from "../composition/composition";
import Complement from "@domain/composition/Complement";
import Counterweight from "@domain/accessories/Counterweight";
import Track from "@domain/accessories/Track";
import ElectricalConnection from "@domain/accessories/ElectricalConnection";
import Reflector from "@domain/accessories/Reflector";

type elementTypes = 'Base' | 'Group' | 'Cluster' | 'Space' | 'Composition' | 'Light' | 'Pendant'

export const getElementClass = (type) => {
	const classTable = {
		Cluster: Cluster,
		Pendant: Pendant,
		Light: Light,
		Composition: Composition,
		Complement: Complement,
		Track: Track,
		ElectricalConnection: ElectricalConnection,
		Reflector: Reflector,
		Counterweight: Counterweight
	}
	return classTable[type] ? classTable[type] : Base
}
class DomainFactory {
	familyData: DomainModelsData | undefined
	constructor(familyData?) {
		this.familyData = familyData
	}

	static createElement(element: elementTypes, props) {
		/* TODO -> Started method to unify all new element instantiations across the code in a single place */
	}

	getElement(element) {
		const ele = getElementClass(element.type)
		let instance = ele.fromJSON(element, { domainFactory: this }, null, this.familyData ? this.familyData[element.props.code] : null)
		return instance;
	}

	getType(element: ComposableElement) {
		return DomainFactory.getType(element)
	}

	static getType(element: ComposableElement | Base) {
		if (!element)
			return null
		else if ((element as ComposableElement).element)
			return (element as ComposableElement)?.element?.getClassName() ?? null
		else
			return (element as Base)?.getClassName() ?? null
	}

	mountComposition(virtualGroup: Group): { composition: Composition, space: Space } {
		if (!virtualGroup.isVirtual() || !virtualGroup.getElements()) return
		/* FIXME */
		/* Mal en un futuro -> Se presupone que el Light.getParent() es el Cluster immediatamente hijo del Espacio */
		/* La circus -> Tendrá clusters dentro de clusters (?), por lo que el Light.getParent() puede tener como parent otro cluster*/
		/* Ahora mismo cluster, no está preparado para tener hijos clusters todavía */
		const clusters: CompositionElement[] = virtualGroup.getElements()
			.map((composableLightElement: ComposableElement) => {
				const cluster = composableLightElement.element.getParent() as Cluster
				const space = composableLightElement.element.getParent().getParent() as Space
				return {
					element: cluster, /* No siempre será cierto (lee arriba ☝🏻)*/
					options: {
						position: space.getElement(cluster).options?.position ?? [0, 0, 0]
					}
				}
			})
			.filter((composableElement, index, array) => /* Magia oscura para eliminar duplicados */
				index == array.findIndex(compoElement =>
					composableElement.element.getId() == compoElement.element.getId()
				)
			)

		if (!clusters.every(cluster => cluster.element.getParent() == clusters[0].element.getParent()))
			throw 'Hay clusters con distintos padres'

		let space = clusters[0].element.getParent() as Space

		const composition = new Composition(clusters, space)
		space = space.addElement({ element: composition, options: { position: [0, 0, 0] } })
		// TODO: -> Calcular la posicion de: (cluster relativo a la composicion) y (composicion relativo a space)
		/* Al espacio */
		/* Posicionamos la composición en el espacio */
		/* A los clusters */
		// clusters.forEach(cluster => cluster.element.setParent(composicion))
		/* Cambiamos el posicionamiento de los clusters, ahora ya no están relativos al espacio -> Están relativos en el composition */
		return { space, composition };
	}

	unmountComposition(composition: Composition) {
		let space = composition.getParent() as Space;
		let clusters = composition.getElements();

		const lights = composition.getLights()
		lights.forEach(light => {
			const isNoDriver = light.element.getAttributeModifier("control") === "M"
			if (isNoDriver) {
				light.element.deleteAttribute("control")
			}
		})

		clusters.forEach((element: ComposableElement) => { // Clusters(padres): Composition --> Space
			element.element.setParent(space.getInstance());
			space = space.addElement(element as SpaceElement);// Space(hijos): (Composition*)+hijos --> (Clusters*)+hijos
		})
		space = space.remove(composition); // Space remove Composition*
		// TODO: adjust positions
		return space
	}
}

export default DomainFactory